import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface CgvPayload {
  channel: string;
}

// Télécharge le PDF "Conditions générales de vente" (texte réel par canal, repris de beone) via
// /api/communication/cgv/pdf.
export const useDownloadCgv = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadCgv = useCallback(
    async (payload: CgvPayload): Promise<boolean> => {
      if (!isReady) return false;
      setLoading(true);
      setError(null);
      try {
        const blob: Blob = await authFetch('/communication/cgv/pdf', {
          method: 'POST',
          headers: { Accept: 'application/pdf' },
          body: JSON.stringify(payload),
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'cgv.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        return true;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erreur lors du téléchargement des CGV');
        return false;
      } finally {
        setLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { downloadCgv, loading, error };
};
